import { IonButton, IonIcon, IonText } from '@ionic/react'
import { chevronForwardOutline } from 'ionicons/icons'
import React from 'react'
import styled from 'styled-components'
import { TextStyle } from '../../../components'

type Props = {
  id: number
  title: string
  artist: string
  img: string
}

export const ProductInfo: React.FC<Props> = ({ title, artist, img, id }) => {
  return (
    <>
      <ProductContainer>
        <ProductInfoContainer>
          <img
            src={img}
            alt={'이미지'}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null
              currentTarget.src = '/img/thumbnail.svg'
            }}
          />
          <div className="product-info">
            <IonText className="artist">{artist}</IonText>
            <IonText className="title">{title}</IonText>
          </div>
        </ProductInfoContainer>
        <DetailLinkContainer>
          <IonButton size="small" fill="clear" color="medium" routerLink={`/myPage/asset/${id}/description`}>
            <TextStyle type={'r_13'}>작품 상세보기</TextStyle>
            <IonIcon icon={chevronForwardOutline} />
          </IonButton>
        </DetailLinkContainer>
      </ProductContainer>
    </>
  )
}

const ProductContainer = styled.div`
  padding: 24px 20px;
`

const ProductInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  img {
    border-radius: 7px;
    min-width: 52px;
    width: 100%;
    aspect-ratio: 1/1;
    object-fit: cover;
  }
  .product-info {
    grid-area: 1 / 2 / 2 / 6;
    display: flex;
    flex-direction: column;
    font-size: 15px;
    .artist {
      white-space: nowrap;
      color: var(--ion-color-primary_light);
      font-size: 13px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-wrap: break-word;
      line-height: 1.2em;
      max-height: 40px;
    }
  }
`

const DetailLinkContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  ion-button {
    --padding-end: 0;
    padding: 0;
    margin: 0;
  }
`
